export default {
	data() {
		return {
			componentID: 0,
		};
	},
	created() {
		this.$store.dispatch("generateID");
		this.componentID = this.$store.state.newComponentID;
	},
};



// WEBPACK FOOTER //
// ./src/mixins/unique-ids.js